import { gql } from '@apollo/client';

export const BASIC_POINT_FIELDS = gql`
    fragment BasicPointFields on Point {
        PointId
        x
        y
        z
        State
        WGS84_lat
        WGS84_long
    }
`;
